import {
  Email,
  LocationOn,
  Phone,
  Print,
  PhoneAndroid,
  Message,
} from '@mui/icons-material';

const iconComponents = {
  email: Email,
  phone: Phone,
  print: Print,
  locationOn: LocationOn,
  phoneAndroid: PhoneAndroid,
  message: Message,
} as const;

export type CareTeamIconVariant = keyof typeof iconComponents;

export interface CareTeamIconProps {
  variant: CareTeamIconVariant;
}

export const CareTeamIcon = ({ variant }: CareTeamIconProps) => {
  const Icon = iconComponents[variant];
  return <Icon sx={{ height: '16px', color: 'rgba(0, 0, 0, 0.60)' }} />;
};
